export default __webpack_public_path__ + "static/landing-5-36deb52d37be1c72c0d7004fdcd0e343.png";